<template>
  <div class="xinsheng-warp">
    <FilterForm
      :formData="filterData"
      :filters="filters"
      @changeDept="changeDept"
      @submit="handleSubmit"
      @reset="handleReset"
    />

    <CustomerTable
      v-if="tableData"
      :tableColumn="tableColumn"
      :tableData="tableData"
      @downloadVoice="handleDownloadVoice"
      @nameDrawer="handleNameDrawer"
    />
    <CustomerPagination
      :total="total"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
    />
    <CustomerDetail
      width="1200px"
      :isShowDialog="isShowDialog"
      @close="handleClose"
      direction="rtl"
      :userId="userId"
      @next="handleNextCustomer"
      @prev="handlePrevCustomer"
    />
  </div>

</template>

<script>
import FilterForm from "@/components/filter";
import { computed, onMounted, reactive, ref } from "vue";
import { tableColumn } from "./index.js";
import CustomerTable from "@/components/table";
import CustomerPagination from "@/components/pagination";
import { useStore } from "vuex";
import { getUserByDept } from "@/api/method/common";
import CustomerDetail from "@/components/drawer-form/index.vue";
import { reset } from "@/until";
import { ElMessage } from "element-plus";

export default {
  name: "ClientVisit",
  components: {
    FilterForm,
    CustomerTable,
    CustomerPagination,
    CustomerDetail,
  },
  setup() {
    const { dispatch, state } = useStore();
    const filterData = reactive({
      deptId: null,
      userId: null,
      search: null,
      date: null,
    });
    const filters = reactive([
      [
        {
          label: "选择部门",
          type: "select",
          attr: "deptId",
          placeholder: "请选择",
          column: 8,
          option: [],
          labelWidth: "80px",
        },
        {
          label: "选择顾问",
          type: "select",
          attr: "userId",
          placeholder: "请选择",
          column: 8,
          option: [],
          labelWidth: "100px",
        },
        {
          label: "通话号码",
          type: "input",
          attr: "telephone",
          placeholder: "请输入要搜索的手机号",
          suffixIcon: "el-icon-search",
          column: 8,
          labelWidth: "74px",
        },
        {
          label: "呼叫时间",
          type: "dateRange",
          attr: "date",
          column: 8,
          labelWidth: "80px",
          valueFormat: "YYYY-MM-DD",
        },
        {
          type: "button",
          column: 4,
        },
      ]
    ]);

    const pagination = reactive({
      page: 1,
      size: 10,
    });

    const tableData = computed(
      () => state.callRecordList && state.callRecordList.records
    );
    const total = computed(
      () => state.callRecordList && state.callRecordList.total
    );
    const getDepartList = async () => {
      await dispatch("departmentList");
      filters[0][0].option = state.departmentList.map((item) => ({
        label: item.fullName,
        val: item.id,
      }));
    };
    const changeDept = async (id) => {
      const res = await getUserByDept(id);
      filters[0][1].option = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
    };

    const handleDownloadVoice = (path)=>{
      console.log("handleDownloadVoice")
      window.location.href = path;
    }

    const getList = () => {
      const { date, ...param } = filterData;

      const startTime = date && date[0];
      const endTime = date && date[1];

      dispatch("callRecordList", {
        ...pagination,
        ...param,
        startTime,
        endTime,
      });
    };

    onMounted(() => {
      getList();
      getDepartList();
    });

    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };

    const handleSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };
    const isShowDialog = ref(false);
    const handleClose = () => (isShowDialog.value = false);
    const userId = ref(null);
    const handleNameDrawer = (row) => {
      isShowDialog.value = true;
      userId.value = row.customerId;
    };
    const handleNextCustomer = () => {
      const index =
        state.customerVisit.records.findIndex(
          (item) => item.customerId == userId.value
        ) + 1;
      if (index == state.customerVisit.records.length) {
        ElMessage.error("已经是最后一个客户了！");
        return;
      }
      userId.value = state.customerVisit.records[index].customerId;
    };
    const handlePrevCustomer = () => {
      const index =
        state.customerVisit.records.findIndex(
          (item) => item.customerId == userId.value
        ) - 1;
      if (index < 0) {
        ElMessage.error("已经是第一个客户了！");
        return;
      }
      userId.value = state.customerVisit.records[index].customerId;
    };

    return {
      filters,
      filterData,
      tableColumn,
      tableData,
      total,
      changeDept,
      currentChange,
      sizeChange,
      handleSubmit,
      handleReset,
      isShowDialog,
      handleClose,
      handleNameDrawer,
      userId,
      handleNextCustomer,
      handlePrevCustomer,
      handleDownloadVoice,
    };
  },
};
</script>

<style lang="scss" scoped>
.user-btn {
  padding-bottom: 40px;
}
.container {
  display: flex;
  min-height: 100%;
  .left {
    width: 250px;
    background: #f5f6f9;
    margin-right: 24px;
    padding: 20px;
  }
  .right {
    flex: 1;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.company-block {
  margin-bottom: 20px;
}

.company-block .el-input__inner {
  background: white !important;
}
.depart-tree {
  background: #f5f6f9;
  .el-tree-node__content {
    background: #f5f6f9;
  }
}
</style>
